import { DispensationStrategy } from "elephant-web/gql";
import type { MigrationStrategies } from "./_types/migration-strategies";

export const DISPENSATION_MIGRATION_STRATEGIES: MigrationStrategies = {
  1: (oldDoc) => oldDoc,
  2: (oldDoc) => {
    oldDoc.dispensationStrategy = oldDoc.alternativeDispensed
      ? DispensationStrategy.ProvidedAlternativeClinicalProduct
      : DispensationStrategy.ProvidedIntendedClinicalProduct;
    return oldDoc;
  },
};
